import { ReactComponent as GoogleAds } from '../../images/icon-components/networks/googleads/white.svg'
import { ReactComponent as GoogleAdsWhiteRounded } from '../../images/icon-components/networks/googleads/white-rounded.svg'
import { ReactComponent as GoogleAdsDarkRounded } from '../../images/icon-components/networks/googleads/dark-rounded.svg'
//import { ReactComponent as GoogleAdsDark } from '../../images/icon-components/networks/googleads/dark.svg'

import { ReactComponent as GoogleAnalyticsWhiteRounded } from '../../images/icon-components/networks/google-analytics/white-rounded.svg'
import { ReactComponent as GoogleAnalyticsDarkRounded } from '../../images/icon-components/networks/google-analytics/dark-rounded.svg'

import { ReactComponent as Apple } from '../../images/icon-components/networks/apple/white.svg'
import { ReactComponent as AppleDark } from '../../images/icon-components/networks/apple/dark.svg'
import { ReactComponent as AppleWhiteRounded } from '../../images/icon-components/networks/apple/white-rounded.svg'
import { ReactComponent as AppleDarkRounded } from '../../images/icon-components/networks/apple/dark-rounded.svg'

import { ReactComponent as DirectAdvert } from '../../images/icon-components/networks/directadvert/white.svg'
//import { ReactComponent as DirectAdvertDark } from '../../images/icon-components/networks/directadvert/dark.svg'
import { ReactComponent as DirectAdvertWhiteRounded } from '../../images/icon-components/networks/directadvert/white-rounded.svg'
import { ReactComponent as DirectAdvertDarkRounded } from '../../images/icon-components/networks/directadvert/dark-rounded.svg'

import { ReactComponent as Facebook } from '../../images/icon-components/networks/facebook/white.svg'
import { ReactComponent as FacebookWhiteRounded } from '../../images/icon-components/networks/facebook/white-rounded.svg'
import { ReactComponent as FacebookDarkRounded } from '../../images/icon-components/networks/facebook/dark-rounded.svg'
//import { ReactComponent as FacebookDark } from '../../images/icon-components/networks/facebook/dark.svg'

import { ReactComponent as GetuniqWhiteRounded } from '../../images/icon-components/networks/getuniq/white-rounded.svg'
import { ReactComponent as GetuniqDarkRounded } from '../../images/icon-components/networks/getuniq/dark-rounded.svg'
//import { ReactComponent as GetuniqRoundedDark } from '../../images/icon-components/networks/getuniq-rounded/dark.svg'

import { ReactComponent as YandexBusiness } from '../../images/icon-components/networks/yandex-business/white.svg'
import { ReactComponent as YandexBusinessWhiteRounded } from '../../images/icon-components/networks/yandex-business/white-rounded.svg'
import { ReactComponent as YandexBusinessDarkRounded } from '../../images/icon-components/networks/yandex-business/dark-rounded.svg'
//import { ReactComponent as YandexBusinessDark } from '../../images/icon-components/networks/yandex-business/dark.svg'

import { ReactComponent as PornHub } from '../../images/icon-components/networks/pornhub/white.svg'
import { ReactComponent as PornHubWhiteRounded } from '../../images/icon-components/networks/pornhub/white-rounded.svg'
import { ReactComponent as PornHubDarkRounded } from '../../images/icon-components/networks/pornhub/dark-rounded.svg'
//import { ReactComponent as PornHubDark } from '../../images/icon-components/networks/pornhub/dark.svg'

import { ReactComponent as Vk } from '../../images/icon-components/networks/vk/white.svg'
import { ReactComponent as VkDark } from '../../images/icon-components/networks/vk/dark.svg'
import { ReactComponent as VkWhiteRounded } from '../../images/icon-components/networks/vk/white-rounded.svg'
import { ReactComponent as VkDarkRounded } from '../../images/icon-components/networks/vk/dark-rounded.svg'

import { ReactComponent as AdsMarket } from '../../images/icon-components/networks/adsmarket/white.svg'
//import { ReactComponent as AdsMarketDark } from '../../images/icon-components/networks/adsmarket/dark.svg'

import { ReactComponent as Gnezdo } from '../../images/icon-components/networks/gnezdo/white.svg'
import { ReactComponent as GnezdoWhiteRounded } from '../../images/icon-components/networks/gnezdo/white-rounded.svg'
import { ReactComponent as GnezdoDarkRounded } from '../../images/icon-components/networks/gnezdo/dark-rounded.svg'
//import { ReactComponent as GnezdoDark } from '../../images/icon-components/networks/gnezdo/dark.svg'

import { ReactComponent as Marketgid } from '../../images/icon-components/networks/marketgid/white.svg'
import { ReactComponent as MarketgidDark } from '../../images/icon-components/networks/marketgid/dark.svg'
import { ReactComponent as MarketgidWhiteRounded } from '../../images/icon-components/networks/marketgid/white-rounded.svg'
import { ReactComponent as MarketgidDarkRounded } from '../../images/icon-components/networks/marketgid/dark-rounded.svg'

import { ReactComponent as MyTarget } from '../../images/icon-components/networks/mytarget/white.svg'
import { ReactComponent as MyTargetWhiteRounded } from '../../images/icon-components/networks/mytarget/white-rounded.svg'
import { ReactComponent as MyTargetDarkRounded } from '../../images/icon-components/networks/mytarget/dark-rounded.svg'
//import { ReactComponent as MyTargetDark } from '../../images/icon-components/networks/mytarget/dark.svg'

import { ReactComponent as MyTargetInt } from '../../images/icon-components/networks/mytargetint/white.svg'
//import { ReactComponent as MyTargetIntDark } from '../../images/icon-components/networks/mytargetint/dark.svg'

import { ReactComponent as Sape } from '../../images/icon-components/networks/sape/white.svg'
import { ReactComponent as SapeWhiteRounded } from '../../images/icon-components/networks/sape/white-rounded.svg'
import { ReactComponent as SapeDarkRounded } from '../../images/icon-components/networks/sape/dark-rounded.svg'
//import { ReactComponent as SapeDark } from '../../images/icon-components/networks/sape/dark.svg'

import { ReactComponent as TikTok } from '../../images/icon-components/networks/tiktok/white.svg'
//import { ReactComponent as TikTokDark } from '../../images/icon-components/networks/tiktok/dark.svg'
import { ReactComponent as TikTokWhiteRounded } from '../../images/icon-components/networks/tiktok/white-rounded.svg'
import { ReactComponent as TikTokDarkRounded } from '../../images/icon-components/networks/tiktok/dark-rounded.svg'

import { ReactComponent as Yahoo } from '../../images/icon-components/networks/yahoo/white.svg'
import { ReactComponent as YahooWhiteRounded } from '../../images/icon-components/networks/yahoo/white-rounded.svg'
import { ReactComponent as YahooDarkRounded } from '../../images/icon-components/networks/yahoo/dark-rounded.svg'
//import { ReactComponent as YahooDark } from '../../images/icon-components/networks/yahoo/dark.svg'

import { ReactComponent as Yandex } from '../../images/icon-components/networks/yandex/white.svg'
//import { ReactComponent as YandexDark } from '../../images/icon-components/networks/yandex/dark.svg'

import { ReactComponent as YandexWhiteRounded } from '../../images/icon-components/networks/yandex/white-rounded.svg'
import { ReactComponent as YandexDarkRounded } from '../../images/icon-components/networks/yandex/dark-rounded.svg'
//import { ReactComponent as YandexRoundedDark } from '../../images/icon-components/networks/yandex-rounded/dark.svg'

import { ReactComponent as Instagram } from '../../images/icon-components/networks/instagram/white.svg'
import { ReactComponent as InstagramWhiteRounded } from '../../images/icon-components/networks/instagram/white-rounded.svg'
import { ReactComponent as InstagramDarkRounded } from '../../images/icon-components/networks/instagram/dark-rounded.svg'
//import { ReactComponent as InstagramDark } from '../../images/icon-components/networks/instagram/dark.svg'

import { ReactComponent as Telegram } from '../../images/icon-components/networks/telegram/white.svg'
import { ReactComponent as TelegramWhiteRounded } from '../../images/icon-components/networks/telegram/white-rounded.svg'
import { ReactComponent as TelegramDarkRounded } from '../../images/icon-components/networks/telegram/dark-rounded.svg'
//import { ReactComponent as TelegramDark } from '../../images/icon-components/networks/telegram/dark.svg'

import { ReactComponent as Ok } from '../../images/icon-components/networks/ok/white.svg'
import { ReactComponent as OkWhiteRounded } from '../../images/icon-components/networks/ok/white-rounded.svg'
import { ReactComponent as OkDarkRounded } from '../../images/icon-components/networks/ok/dark-rounded.svg'
//import { ReactComponent as OkDark } from '../../images/icon-components/networks/ok/dark.svg'

import { ReactComponent as Twitter } from '../../images/icon-components/networks/twitter/white.svg'
import { ReactComponent as TwitterWhiteRounded } from '../../images/icon-components/networks/twitter/white-rounded.svg'
import { ReactComponent as TwitterDarkRounded } from '../../images/icon-components/networks/twitter/dark-rounded.svg'
//import { ReactComponent as TwitterDark } from '../../images/icon-components/networks/twitter/dark.svg'

import { ReactComponent as Admitad } from '../../images/icon-components/networks/admitad/white.svg'
//import { ReactComponent as AdmitadDark } from '../../images/icon-components/networks/admitad/dark.svg'

import { ReactComponent as VkAdblogger } from '../../images/icon-components/networks/vk-adblogger/white.svg'
import { ReactComponent as VkAdbloggerWhiteRounded } from '../../images/icon-components/networks/vk-adblogger/white-rounded.svg'
import { ReactComponent as VkAdbloggerDarkRounded } from '../../images/icon-components/networks/vk-adblogger/dark-rounded.svg'

//import { ReactComponent as VkAdbloggerDark } from '../../images/icon-components/networks/vk-adblogger/dark.svg'

import { ReactComponent as Taboola } from '../../images/icon-components/networks/taboola/white.svg'
import { ReactComponent as TaboolaDark } from '../../images/icon-components/networks/taboola/dark.svg'
import { ReactComponent as TaboolaWhiteRounded } from '../../images/icon-components/networks/taboola/white-rounded.svg'
import { ReactComponent as TaboolaDarkRounded } from '../../images/icon-components/networks/taboola/dark-rounded.svg'

import { ReactComponent as Avito } from '../../images/icon-components/networks/avito/white.svg'
import { ReactComponent as AvitoDark } from '../../images/icon-components/networks/avito/dark.svg'
import { ReactComponent as AvitoWhiteRounded } from '../../images/icon-components/networks/avito/white-rounded.svg'
import { ReactComponent as AvitoDarkRounded } from '../../images/icon-components/networks/avito/dark-rounded.svg'

import { ReactComponent as Zeropark } from '../../images/icon-components/networks/zeropark/white.svg'
import { ReactComponent as ZeroparkDark } from '../../images/icon-components/networks/zeropark/dark.svg'
import { ReactComponent as ZeroparkWhiteRounded } from '../../images/icon-components/networks/zeropark/white-rounded.svg'
import { ReactComponent as ZeroparkDarkRounded } from '../../images/icon-components/networks/zeropark/dark-rounded.svg'

import { ReactComponent as PetalAds } from '../../images/icon-components/networks/petal-ads/white.svg'
//import { ReactComponent as PetalAdsDark } from '../../images/icon-components/networks/petal-ads/dark.svg'
import { ReactComponent as PetalAdsWhiteRounded } from '../../images/icon-components/networks/petal-ads/white-rounded.svg'
import { ReactComponent as PetalAdsDarkRounded } from '../../images/icon-components/networks/petal-ads/white-rounded.svg'

import { ReactComponent as Bigo } from '../../images/icon-components/networks/bigo/white.svg'
//import { ReactComponent as BigoDark } from '../../images/icon-components/networks/bigo/dark.svg'
import { ReactComponent as BigoWhiteRounded } from '../../images/icon-components/networks/bigo/white-rounded.svg'
import { ReactComponent as BigoDarkRounded } from '../../images/icon-components/networks/bigo/dark-rounded.svg'

import { ReactComponent as MiAds } from '../../images/icon-components/networks/mi-ads/white.svg'
//import { ReactComponent as MiAdsDark } from '../../images/icon-components/networks/mi-ads/dark.svg'
import { ReactComponent as MiAdsWhiteRounded } from '../../images/icon-components/networks/mi-ads/white-rounded.svg'
import { ReactComponent as MiAdsDarkRounded } from '../../images/icon-components/networks/mi-ads/dark-rounded.svg'

import { ReactComponent as AppNext } from '../../images/icon-components/networks/appnext/white.svg'
//import { ReactComponent as AppNextDark } from '../../images/icon-components/networks/appnext/dark.svg'
import { ReactComponent as AppNextWhiteRounded } from '../../images/icon-components/networks/appnext/white-rounded.svg'
import { ReactComponent as AppNextDarkRounded } from '../../images/icon-components/networks/appnext/dark-rounded.svg'

import { ReactComponent as Ozon } from '../../images/icon-components/networks/ozon-performance/white.svg'
//import { ReactComponent as OzonDark } from '../../images/icon-components/networks/ozon-performance/dark.svg'
import { ReactComponent as OzonWhiteRounded } from '../../images/icon-components/networks/ozon-performance/white-rounded.svg'
import { ReactComponent as OzonDarkRounded } from '../../images/icon-components/networks/ozon-performance/dark-rounded.svg'

import { ReactComponent as YandexMarket } from '../../images/icon-components/networks/yandex-market/white.svg'
//import { ReactComponent as YandexMarketDark } from '../../images/icon-components/networks/yandex-market/dark.svg'
import { ReactComponent as YandexMarketWhiteRounded } from '../../images/icon-components/networks/yandex-market/white-rounded.svg'
import { ReactComponent as YandexMarketDarkRounded } from '../../images/icon-components/networks/yandex-market/dark-rounded.svg'

import { ReactComponent as YandexPromo } from '../../images/icon-components/networks/yandex-promo/white.svg'
//import { ReactComponent as YandexPromoDark } from '../../images/icon-components/networks/yandex-promo/dark.svg'
import { ReactComponent as YandexPromoWhiteRounded } from '../../images/icon-components/networks/yandex-promo/white-rounded.svg'
import { ReactComponent as YandexPromoDarkRounded } from '../../images/icon-components/networks/yandex-promo/dark-rounded.svg'

import { ReactComponent as VkAds } from '../../images/icon-components/networks/vk-ads/white.svg'
import { ReactComponent as VkAdsDark } from '../../images/icon-components/networks/vk-ads/dark.svg'
import { ReactComponent as VkAdsWhiteRounded } from '../../images/icon-components/networks/vk-ads/white-rounded.svg'
import { ReactComponent as VkAdsDarkRounded } from '../../images/icon-components/networks/vk-ads/dark-rounded.svg'
import { ReactComponent as VkAdsWhiteRoundedV2 } from '../../images/icon-components/networks/vk-ads/white-rounded2.svg'
import { ReactComponent as VkAdsDarkRoundedV2 } from '../../images/icon-components/networks/vk-ads/dark-rounded2.svg'

import { ReactComponent as YandexGeo } from '../../images/icon-components/networks/yandex-geo/white.svg'
import { ReactComponent as YandexGeoDark } from '../../images/icon-components/networks/yandex-geo/dark.svg'
import { ReactComponent as YandexGeoWhiteRounded } from '../../images/icon-components/networks/yandex-geo/white-rounded.svg'
import { ReactComponent as YandexGeoDarkRounded } from '../../images/icon-components/networks/yandex-geo/dark-rounded.svg'

import { ReactComponent as Trafficjunky } from '../../images/icon-components/networks/trafficjunky/white.svg'
//import { ReactComponent as TrafficjunkyDark } from '../../images/icon-components/networks/trafficjunky/dark.svg'
import { ReactComponent as TrafficjunkyWhiteRounded } from '../../images/icon-components/networks/trafficjunky/white-rounded.svg'
import { ReactComponent as TrafficjunkyDarkRounded } from '../../images/icon-components/networks/trafficjunky/dark-rounded.svg'

import { ReactComponent as WowBlogger } from '../../images/icon-components/networks/wowblogger/white.svg'
import { ReactComponent as WowBloggerDark } from '../../images/icon-components/networks/wowblogger/dark.svg'
import { ReactComponent as WowBloggerWhiteRounded } from '../../images/icon-components/networks/wowblogger/white-rounded.svg'
import { ReactComponent as WowBloggerDarkRounded } from '../../images/icon-components/networks/wowblogger/dark-rounded.svg'

import { ReactComponent as UnityAds } from '../../images/icon-components/networks/unity-ads/white.svg'
import { ReactComponent as UnityAdsDark } from '../../images/icon-components/networks/unity-ads/dark.svg'
import { ReactComponent as UnityAdsWhiteRounded } from '../../images/icon-components/networks/unity-ads/white-rounded.svg'
import { ReactComponent as UnityAdsDarkRounded } from '../../images/icon-components/networks/unity-ads/dark-rounded.svg'

import { ReactComponent as MicrosoftAds } from '../../images/icon-components/networks/microsoft-ads/white.svg'
import { ReactComponent as MicrosoftAdsDark } from '../../images/icon-components/networks/microsoft-ads/dark.svg'
import { ReactComponent as MicrosoftAdsDarkRounded } from '../../images/icon-components/networks/microsoft-ads/dark-rounded.svg'
import { ReactComponent as MicrosoftAdsWhiteRounded } from '../../images/icon-components/networks/microsoft-ads/white-rounded.svg'

import { ReactComponent as Sber } from '../../images/icon-components/networks/sber/white.svg'
import { ReactComponent as SberDark } from '../../images/icon-components/networks/sber/dark.svg'
import { ReactComponent as SberWhiteRounded } from '../../images/icon-components/networks/sber/white-rounded.svg'
import { ReactComponent as SberDarkRounded } from '../../images/icon-components/networks/sber/dark-rounded.svg'

import { ReactComponent as AdsterraWhiteRounded } from '../../images/icon-components/networks/adsterra/white-rounded.svg'
import { ReactComponent as AdsterraDarkRounded } from '../../images/icon-components/networks/adsterra/dark-rounded.svg'

import { ReactComponent as OtmWhiteRounded } from '../../images/icon-components/networks/otm/white-rounded.svg'
import { ReactComponent as OtmDarkRounded } from '../../images/icon-components/networks/otm/dark-rounded.svg'

import { ReactComponent as AdgramWhiteRounded } from '../../images/icon-components/networks/adgram/white-rounded.svg'
import { ReactComponent as AdgramDarkRounded } from '../../images/icon-components/networks/adgram/dark-rounded.svg'

import { ReactComponent as MobidrivenWhiteRounded } from '../../images/icon-components/networks/mobidriven/white-rounded.svg'
import { ReactComponent as MobidrivenDarkRounded } from '../../images/icon-components/networks/mobidriven/dark-rounded.svg'

import { ReactComponent as SnapchatWhiteRounded } from '../../images/icon-components/networks/snapchat/white-rounded.svg'
import { ReactComponent as SnapchatDarkRounded } from '../../images/icon-components/networks/snapchat/dark-rounded.svg'

const config = {
  adv: {
    backgroundColor: { white: '#F4F4F4' },
    component: { white: GoogleAds },
  },
  'adv-rounded': {
    backgroundColor: '',
    component: { white: GoogleAdsWhiteRounded, dark: GoogleAdsDarkRounded },
  },
  'google-ads': {
    backgroundColor: { white: '#F4F4F4' },
    component: { white: GoogleAds },
  },
  'google-ads-rounded': {
    backgroundColor: '',
    component: { white: GoogleAdsWhiteRounded, dark: GoogleAdsDarkRounded },
  },
  pornhub: {
    backgroundColor: { white: '#5D5D5D' },
    component: { white: PornHub },
  },
  'pornhub-rounded': {
    backgroundColor: '',
    component: { white: PornHubWhiteRounded, dark: PornHubDarkRounded },
  },
  vk: {
    backgroundColor: { white: '#1573EF', dark: 'none' },
    component: { white: Vk, dark: VkDark },
  },
  'vk-rounded': {
    backgroundColor: { white: '' },
    component: { white: VkWhiteRounded, dark: VkDarkRounded },
  },
  targetmail: {
    backgroundColor: { white: '#DA3831' },
    component: { white: MyTarget },
  },
  'targetmail-rounded': {
    backgroundColor: { white: '' },
    component: { white: MyTargetWhiteRounded, dark: MyTargetDarkRounded },
  },
  mytarget: {
    backgroundColor: { white: '#DA3831' },
    component: { white: MyTarget },
  },
  'mytarget-rounded': {
    backgroundColor: { white: '' },
    component: { white: MyTargetWhiteRounded, dark: MyTargetDarkRounded },
  },
  mytargetint: {
    backgroundColor: { white: '#DA3831' },
    component: { white: MyTargetInt },
  },
  'mytargetint-rounded': {
    backgroundColor: { white: '' },
    component: { white: MyTargetWhiteRounded, dark: MyTargetDarkRounded },
  },
  adsmarket: {
    backgroundColor: { white: '#306AAD' },
    component: { white: Vk, dark: VkDark },
  },
  'adsmarket-rounded': {
    backgroundColor: '',
    component: { white: VkWhiteRounded, dark: VkDarkRounded },
  },
  yd: {
    backgroundColor: { white: '#1A4A7F' },
    component: { white: Yandex },
  },
  'yd-rounded': {
    backgroundColor: '',
    component: { white: YandexWhiteRounded, dark: YandexDarkRounded },
  },
  yandex: {
    backgroundColor: { white: '#1A4A7F' },
    component: { white: Yandex },
  },
  'yandex-rounded': {
    backgroundColor: '',
    component: { white: YandexWhiteRounded, dark: YahooDarkRounded },
  },
  facebook: {
    backgroundColor: { white: '#214FA8' },
    component: { white: Facebook },
  },
  'facebook-rounded': {
    backgroundColor: { white: '' },
    component: { white: FacebookWhiteRounded, dark: FacebookDarkRounded },
  },
  yahoo: {
    backgroundColor: { white: '#6001D2' },
    component: { white: Yahoo },
  },
  'yahoo-rounded': {
    backgroundColor: { white: '' },
    component: { white: YahooWhiteRounded, dark: YahooDarkRounded },
  },
  tiktok: {
    backgroundColor: { white: '#183051' },
    component: { white: TikTok },
  },
  'tiktok-rounded': {
    backgroundColor: '',
    component: { white: TikTokWhiteRounded, dark: TikTokDarkRounded },
  },
  marketgid: {
    backgroundColor: { white: '#EBEBEB', dark: '#0033CC' },
    component: { white: Marketgid, dark: MarketgidDark },
  },
  'marketgid-rounded': {
    backgroundColor: '',
    component: { white: MarketgidWhiteRounded, dark: MarketgidDarkRounded },
  },
  apple: {
    backgroundColor: { white: '#EBEBEB', dark: '#000000' },
    component: { white: Apple, dark: AppleDark },
  },
  'apple-rounded': {
    backgroundColor: { white: '' },
    component: { white: AppleWhiteRounded, dark: AppleDarkRounded },
  },
  'apple-search-ads': {
    backgroundColor: { white: '#EBEBEB', dark: '#000000' },
    component: { white: Apple, dark: AppleDark },
  },
  'apple-search-ads-rounded': {
    backgroundColor: { white: '' },
    component: { white: AppleWhiteRounded, dark: AppleDarkRounded },
  },

  gnezdo: {
    backgroundColor: { white: '#EEC800' },
    component: { white: Gnezdo },
  },
  'gnezdo-rounded': {
    backgroundColor: { white: '' },
    component: { white: GnezdoWhiteRounded, dark: GnezdoDarkRounded },
  },
  'vk-adblogger': {
    backgroundColor: { white: 'none' },
    component: { white: VkAdblogger },
  },
  'vk-adblogger-rounded': {
    backgroundColor: { white: 'none' },
    component: { white: VkAdbloggerWhiteRounded, dark: VkAdbloggerDarkRounded },
  },
  sape: {
    backgroundColor: { white: '#3D7098' },
    component: { white: Sape },
  },
  'sape-rounded': {
    backgroundColor: { white: '' },
    component: { white: SapeWhiteRounded, dark: SapeDarkRounded },
  },
  instagram: {
    backgroundColor: { white: '#E429A0' },
    component: { white: Instagram },
  },
  'instagram-rounded': {
    backgroundColor: { white: '' },
    component: { white: InstagramWhiteRounded, dark: InstagramDarkRounded },
  },
  telegram: {
    backgroundColor: { white: '#00A4EA' },
    component: { white: Telegram },
  },
  'telegram-rounded': {
    backgroundColor: { white: '' },
    component: { white: TelegramWhiteRounded, dark: TelegramDarkRounded },
  },
  'telegram-ads': {
    backgroundColor: { white: '#00A4EA' },
    component: { white: Telegram },
  },
  'telegram-ads-rounded': {
    backgroundColor: { white: '' },
    component: { white: TelegramWhiteRounded, dark: TelegramDarkRounded },
  },
  ok: {
    backgroundColor: { white: '#F7931E' },
    component: { white: Ok },
  },
  'ok-rounded': {
    backgroundColor: { white: '' },
    component: { white: OkWhiteRounded, dark: OkDarkRounded },
  },
  twitter: {
    backgroundColor: { white: '#009FF9' },
    component: { white: Twitter },
  },
  'twitter-rounded': {
    backgroundColor: { white: '' },
    component: { white: TwitterWhiteRounded, dark: TwitterDarkRounded },
  },
  'yandex-business': {
    backgroundColor: { white: '#323555' },
    component: { white: YandexBusiness },
  },

  'yandex-business-rounded': {
    backgroundColor: { white: '' },
    component: {
      white: YandexBusinessWhiteRounded,
      dark: YandexBusinessDarkRounded,
    },
  },

  'google-analytics-rounded': {
    backgroundColor: { white: '#F4F4F4', dark: '#000000' },
    component: {
      white: GoogleAnalyticsWhiteRounded,
      dark: GoogleAnalyticsDarkRounded,
    },
  },
  'getuniq-rounded': {
    backgroundColor: '',
    component: { white: GetuniqWhiteRounded, dark: GetuniqDarkRounded },
  },
  taboola: {
    backgroundColor: { white: '#EBEFF3', dark: '#002852' },
    component: { white: Taboola, dark: TaboolaDark },
  },
  'taboola-rounded': {
    backgroundColor: '',
    component: { white: TaboolaWhiteRounded, dark: TaboolaDarkRounded },
  },
  avito: {
    backgroundColor: { white: '#F2F2F2', dark: '#141412' },
    component: { white: Avito, dark: AvitoDark },
  },
  'avito-rounded': {
    backgroundColor: '',
    component: { white: AvitoWhiteRounded, dark: AvitoDarkRounded },
  },
  zeropark: {
    backgroundColor: { white: '#F2F2F2', dark: '#080821' },
    component: { white: Zeropark, dark: ZeroparkDark },
  },
  'zeropark-rounded': {
    backgroundColor: '',
    component: { white: ZeroparkWhiteRounded, dark: ZeroparkDarkRounded },
  },
  'petal-ads': {
    backgroundColor: { white: 'none' },
    component: { white: PetalAds },
  },
  'petal-ads-rounded': {
    backgroundColor: '',
    component: { white: PetalAdsWhiteRounded, dark: PetalAdsDarkRounded },
  },
  bigo: {
    backgroundColor: { white: '#009DFF' },
    component: { white: Bigo },
  },
  'bigo-rounded': {
    backgroundColor: '',
    component: { white: BigoWhiteRounded, dark: BigoDarkRounded },
  },
  'bigo-ads': {
    backgroundColor: { white: '#009DFF' },
    component: { white: Bigo },
  },
  'bigo-ads-rounded': {
    backgroundColor: '',
    component: { white: BigoWhiteRounded, dark: BigoDarkRounded },
  },
  'mi-ads': {
    backgroundColor: { white: '#FF6700' },
    component: { white: MiAds },
  },
  'mi-ads-rounded': {
    backgroundColor: '',
    component: { white: MiAdsWhiteRounded, dark: MiAdsDarkRounded },
  },
  appnext: {
    backgroundColor: { white: '#060C2E' },
    component: { white: AppNext },
  },
  'appnext-rounded': {
    backgroundColor: '',
    component: { white: AppNextWhiteRounded, dark: AppNextDarkRounded },
  },
  'ozon-performance': {
    backgroundColor: { white: 'none' },
    component: { white: Ozon },
  },
  'ozon-performance-rounded': {
    backgroundColor: '',
    component: { white: OzonWhiteRounded, dark: OzonDarkRounded },
  },
  'yandex-market': {
    backgroundColor: { white: 'none' },
    component: { white: YandexMarket },
  },
  'yandex-market-rounded': {
    backgroundColor: '',
    component: {
      white: YandexMarketWhiteRounded,
      dark: YandexMarketDarkRounded,
    },
  },
  directadvert: {
    backgroundColor: { white: 'none' },
    component: { white: DirectAdvert },
  },
  'directadvert-rounded': {
    backgroundColor: '',
    component: {
      white: DirectAdvertWhiteRounded,
      dark: DirectAdvertDarkRounded,
    },
  },
  'yandex-promo': {
    backgroundColor: { white: 'none' },
    component: { white: YandexPromo },
  },
  'yandex-promo-rounded': {
    backgroundColor: '',
    component: { white: YandexPromoWhiteRounded, dark: YandexPromoDarkRounded },
  },
  'yandex-zen': {
    backgroundColor: { white: 'none' },
    component: { white: YandexPromo },
  },
  'yandex-zen-rounded': {
    backgroundColor: '',
    component: { white: YandexPromoWhiteRounded, dark: YandexPromoDarkRounded },
  },
  'vk-ads': {
    backgroundColor: { white: 'none', dark: 'none' },
    component: { white: VkAds, dark: VkAdsDark },
  },
  /*'vk-ads-rounded': {
    backgroundColor: '',
    component: { white: VkAdsWhiteRounded, dark: VkAdsDarkRounded },
  },*/
  'vk-ads-rounded': {
    backgroundColor: '',
    component: { white: VkAdsWhiteRoundedV2, dark: VkAdsDarkRoundedV2 },
  },
  'yandex-geo': {
    backgroundColor: { white: 'none', dark: '#000' },
    component: { white: YandexGeo, dark: YandexGeoDark },
  },
  'yandex-geo-rounded': {
    backgroundColor: '',
    component: { white: YandexGeoWhiteRounded, dark: YandexGeoDarkRounded },
  },
  'yandex-geoadv': {
    backgroundColor: { white: 'none', dark: '#000' },
    component: { white: YandexGeo, dark: YandexGeoDark },
  },
  'yandex-geoadv-rounded': {
    backgroundColor: '',
    component: { white: YandexGeoWhiteRounded, dark: YandexGeoDarkRounded },
  },
  trafficjunky: {
    backgroundColor: { white: '#2A9DB2' },
    component: { white: Trafficjunky },
  },
  'trafficjunky-rounded': {
    backgroundColor: '',
    component: {
      white: TrafficjunkyWhiteRounded,
      dark: TrafficjunkyDarkRounded,
    },
  },
  wowblogger: {
    backgroundColor: { white: '#E7EDF4', dark: '#3A1E44' },
    component: { white: WowBlogger, dark: WowBloggerDark },
  },
  'wowblogger-rounded': {
    backgroundColor: '',
    component: { white: WowBloggerWhiteRounded, dark: WowBloggerDarkRounded },
  },
  sber: {
    backgroundColor: { white: '#F6F9FD', dark: '#18469B' },
    component: { white: Sber, dark: SberDark },
  },
  'sber-rounded': {
    backgroundColor: '',
    component: { white: SberWhiteRounded, dark: SberDarkRounded },
  },
  'unity-ads': {
    backgroundColor: { white: '#E7EDF4', dark: '#060606' },
    component: { white: UnityAds, dark: UnityAdsDark },
  },
  'unity-ads-rounded': {
    backgroundColor: '',
    component: { white: UnityAdsWhiteRounded, dark: UnityAdsDarkRounded },
  },

  'microsoft-ads': {
    backgroundColor: { white: '#F0F0F0', dark: '#215B61' },
    component: { white: MicrosoftAds, dark: MicrosoftAdsDark },
  },
  'microsoft-ads-rounded': {
    backgroundColor: '',
    component: {
      white: MicrosoftAdsWhiteRounded,
      dark: MicrosoftAdsDarkRounded,
    },
  },
  'microsoft-advertising': {
    backgroundColor: { white: '#F0F0F0', dark: '#215B61' },
    component: { white: MicrosoftAds, dark: MicrosoftAdsDark },
  },
  'microsoft-advertising-rounded': {
    backgroundColor: '',
    component: {
      white: MicrosoftAdsWhiteRounded,
      dark: MicrosoftAdsDarkRounded,
    },
  },
  'adsterra-rounded': {
    backgroundColor: '',
    component: {
      white: AdsterraWhiteRounded,
      dark: AdsterraDarkRounded,
    },
  },
  'adgram-rounded': {
    backgroundColor: '',
    component: {
      white: AdgramWhiteRounded,
      dark: AdgramDarkRounded,
    },
  },
  'otm-rounded': {
    backgroundColor: '',
    component: {
      white: OtmWhiteRounded,
      dark: OtmDarkRounded,
    },
  },
  'mobidriven-rounded': {
    backgroundColor: '',
    component: {
      white: MobidrivenWhiteRounded,
      dark: MobidrivenDarkRounded,
    },
  },
  'snapchat-rounded': {
    backgroundColor: '',
    component: {
      white: SnapchatWhiteRounded,
      dark: SnapchatDarkRounded,
    },
  },
  admitad: {
    backgroundColor: { white: '#7D34DA' },
    component: { white: Admitad },
  },
}

export default config
